import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=5c22c7bd"
import script from "./CarouselCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=5c22c7bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports